// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"9da11a87","556":"254f7853"}[chunkId] + ".chunk.css";
};